export const isDevelopment = (): boolean =>
  !process?.env.REACT_APP_ENV || process?.env.REACT_APP_ENV === 'development';

export const isAcceptance = (): boolean =>
  process?.env.REACT_APP_ENV === 'acceptance';

export const isProduction = (): boolean =>
  process?.env.REACT_APP_ENV === 'production';
